export default {
	unauthtorized: 'your account',
};
